var a={Table:"BasicTable__Table-P9p",stickedHead:"BasicTable__stickedHead-w9D",subRow:"BasicTable__subRow-I4z"};export{a as default};
